import * as React from 'react';
import SwaggerUIConstructor from 'swagger-ui';
import { SwaggerConfigs, SwaggerRequest, SwaggerResponse } from 'swagger-ui-dist';
import 'swagger-ui-react/swagger-ui.css';

export type System = any;
export type Selector = any;
export type State = any;

export type RequestInterceptorType = (req: SwaggerRequest) => Promise<SwaggerRequest>;
export type ResponseInterceptorType = (req: SwaggerResponse) => Promise<SwaggerResponse>;

interface SwaggerComponentProps extends Omit<SwaggerConfigs, 'requestInterceptor' | 'responseInterceptor'> {
  requestInterceptor: RequestInterceptorType;
  responseInterceptor: ResponseInterceptorType;
  isGrpc?: boolean;
}

export function SwaggerComponent(props: SwaggerComponentProps) {
  React.useEffect(() => {
    SwaggerUIConstructor({
      spec: props.spec,
      plugins: [props.plugins],
      dom_id: '#swagger',
      withCredentials: true,
      deepLinking: true,
      showMutatedRequest: props.isGrpc,
      oauth2RedirectUrl: props.oauth2RedirectUrl,
      requestInterceptor: props.requestInterceptor,
      responseInterceptor: props.responseInterceptor,
      syntaxHighlight: { activated: false }
    } as SwaggerComponentProps);
  }, [props.specId]);

  return <div id='swagger' />;
}
